import React from 'react'

const Error = () => {
  return (
    <div className='flex justify-center items-center text-5xl  py-[12px] px-[12px] text-white'>
      This course will be uploaded soon...    
    </div>

  )
}

export default Error
